"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { getAssetUrl } from "@/utils/assetUrl";
import { trackCtaClick } from "@/utils/commonEvents";

const RESMED_URL = "https://www.resmed.com";

export default function Header() {
  const t = useTranslations("common");

  const handleLogoClick = () => {
    trackCtaClick({
      componentName: "Header",
      clickedArea: "logo",
      clickedText: t("resmed-logo-alt"),
      clickedUrl: RESMED_URL,
    });
  };

  return (
    <header className="header">
      <div className="header-content">
        <a
          href={RESMED_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="header-logo-link"
          aria-label={t("resmed-logo-alt")}
          onClick={handleLogoClick}
        >
          <Image
            className="header-logo"
            src={getAssetUrl("/images/resmed_logo.svg")}
            alt={t("resmed-logo-alt")}
            width={166}
            height={44}
            unoptimized
          />
        </a>
      </div>
    </header>
  );
}
